import * as echarts from 'echarts'

export function optionone() {
    var option = {
        title:{
            text: '1#2主变电负荷电流变化',
            textStyle: {
                color: '#fff',
                fontSize: '12',
            },
            padding: 0,
            top: 3,
            left: '20%',
        },
        legend: {
            top: 17,
            right: 30,
            icon: 'roundRect',
            itemWidth: 10,
            itemHeight: 8,
            itemGap: 15,
            textStyle: {
                fontFamily: 'MicrosoftYaHei',
                fontSize: 14,
                color: 'rgba(255, 255, 255, 1)'
            },
            data: ['电流']
        },
        grid: {
            top: '15%',
            left: '5%',
            right: '5%',
            bottom: '10%',
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'line',
                lineStyle: {
                    color: '#fff',
                },
            },
            backgroundColor: 'rgba(42, 51, 74, 1)',
            borderColor: 'transparent',
            formatter: function (params) {
                let colors = ['rgba(26, 126, 117, 1)', 'rgba(233, 195, 116, 1)']
                let returnData = '<div style="padding: 5px 10px;">'
                returnData += '<span style="font-family: MicrosoftYaHei; font-size: 14px; color: rgba(210, 221, 249, 1);">' + params[0].axisValue + '</span><br/>'
                for (let i = 0; i < params.length; i++) {
                    returnData += '<span style="display:inline-block; width:10px; height:8px; margin-right:5px; border-radius:1px; background-color:' + colors[i] + '"></span>'
                    returnData += '<span style="font-family: MicrosoftYaHei; font-size: 14px; color: ' + colors[i] + '">' + params[i].seriesName + '：</span><span style="font-family: Verdana; font-size: 14px; color: ' + colors[i] + '">' + params[i].value + '</span><span style="display:inline-block; margin-left: 4px; line-height: 10px; font-family: MicrosoftYaHei; font-size: 12px; color: ' + colors[i] + '">车</span><br/>'
                }
                returnData += '</div>'
                return returnData
            }
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc',
                    width:1
                },
            },
            splitLine: {
                show: false,
            },
            axisLabel: {
                fontFamily: 'MicrosoftYaHei',
                fontSize: 12,
                color: '#fff',
            },
            axisTick: {
                show: false,
                alignWithLabel: true,
            },
            boundaryGap: false,
            data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00'],
        },
        yAxis: {
            type: 'value',
            name: '（A)',
            nameTextStyle: {
                fontFamily: 'MicrosoftYaHei',
                fontSize: 12,
                color: '#fff',
            },
            splitLine: {
                show: false,
            },
            min: 0,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#ccc',
                    width:1
                },
            },
            axisLabel: {
                show: true,
                margin: 20,
                textStyle: {
                    fontFamily: 'MicrosoftYaHei',
                    fontSize: 12,
                    color: '#fff',
                },
            },
            axisTick: {
                show: false,
            },
        },
        series: [
            {
                name: '计划量',
                type: 'line',
                showAllSymbol: true,
                symbol: 'none',
                symbolSize: 5,
                lineStyle: {
                    color: 'rgba(26, 126, 117, 1)'
                },
                label: {
                    show: false
                },
                itemStyle: {

                },
                areaStyle: {
                    normal: {
                        color: new echarts.graphic.LinearGradient(
                            0,
                            0,
                            0,
                            1,
                            [
                                {
                                    offset: 0,
                                    color: 'rgba(26, 126, 117, 0.8)',
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(26, 126, 117, 0)',
                                },
                            ],

                        ),

                    },
                },
                data: [502.84, 205.97, 332.79, 281.55, 398.35, 214.02],
            }
        ],
    };
    return option
}
export function optiontwo() {
    let dataC1 = [20, 30, 60, 40];
    let dataC2 = [20, 30, 60, 40];

    let xData = ['变压器', 'GIS', '开关柜', '电缆'];
    let legendData = ['缺陷数', '巡视数'];
    var option = {
        backgroundColor: '',
        grid: {
            left: '10%',
            right: '2%',
            top: '10%',
            bottom: '13%',
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
                lineStyle: {
                    color: '#57617B',
                },
            },
        },
        legend: {
            data: [
                { name:'缺陷数',itemStyle: {color: '#fff'},textStyle: {color: '#fff'} },
                { name:'巡视数',itemStyle: {color: '#1a8379'},textStyle: {color: '#1a8379'}}
            ],
            right: '8%',
            top: '2%',
            itemHeight:12,
            itemWidth:12,
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                },
            },

            axisTick: {
                show: false,
                alignWithLabel: true,
                lineStyle: {
                    color: '#3585d5',
                },
            },
            axisLabel: {
                fontSize: 12,
                color:'#fff'
            },
            data: xData,
        },
        yAxis: {
            nameTextStyle:{
                color: '#A2D4E6',
            },
            type: 'value',
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#fff',
                },
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dotted',
                    color: '#3585d5',
                },
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                fontSize: 12,
                color:'#fff'
            },
            boundaryGap: ['20%', '20%'],
        },
        series: [
            {
                name: legendData[1],
                barWidth:12,
                type: 'bar',
                smooth: true,
                symbol: 'none',
                showSymbol: false,
                symbolSize: 0,
                itemStyle: {
                    color: {
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        type: 'linear',
                        global: false,
                        colorStops: [
                            {
                                offset: 0,
                                color: 'rgba(26,131,121,1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(0,0,0,0)',
                            },
                        ],
                    },
                },
                data: dataC1,
            },
            {
                name: legendData[0],
                type: 'bar',
                barWidth:12,
                smooth: true,
                symbol: 'none',
                showSymbol: false,
                symbolSize: 0,
                itemStyle: {
                    color: {
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        type: 'linear',
                        global: false,
                        colorStops: [
                            {
                                offset: 0,
                                color: 'rgba(255,255,255,1)',
                            },
                            {
                                offset: 1,
                                color: 'rgba(0,0,0,0)',
                            },
                        ],
                    },
                },
                data: dataC2,
            },
        ],
    };
    return option;
}
